<div class="blog__swiper swiper">
    <div class="swiper-wrapper">
        <a href="" class="blog__slide swiper-slide">
            <div class="blog__slide-tags">
                <div class="blog__slide-tag tag">Gaming</div>
            </div>
            <img class="blog__slide-img" src="/assets/image/blog/slide1.jpg" alt="slide1">
            <div class="blog__slide-content">
                <h3 class="blog__slide-title">Purus auctor auctor sociis massa lectus egestas elementum. Amet
                    quam sit
                    nisl eget.</h3>
                <div class="blog__slide-info">
                    <div class="blog__slide-date">November 23, 2022</div>
                    <span>
                        <svg width="4" height="4" viewBox="0 0 4 4" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <circle cx="2" cy="2" r="2" fill="#9195A1" />
                        </svg>
                    </span>
                    <div class="blog__slide-name">Jhon Frinz</div>
                </div>
            </div>
        </a>
        <a href="" class="blog__slide swiper-slide">
            <div class="blog__slide-tags">
                <div class="blog__slide-tag tag">Gaming</div>
            </div>
            <img class="blog__slide-img" src="/assets/image/blog/slide2.jpg" alt="slide2">
            <div class="blog__slide-content">
                <h3 class="blog__slide-title">Purus auctor auctor sociis massa lectus egestas elementum. Amet
                    quam sit
                    nisl eget.</h3>
                <div class="blog__slide-info">
                    <div class="blog__slide-date">November 23, 2022</div>
                    <span>
                        <svg width="4" height="4" viewBox="0 0 4 4" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <circle cx="2" cy="2" r="2" fill="#9195A1" />
                        </svg>
                    </span>
                    <div class="blog__slide-name">Jhon Frinz</div>
                </div>
            </div>
        </a>
        <a href="" class="blog__slide swiper-slide">
            <div class="blog__slide-tags">
                <div class="blog__slide-tag tag">Gaming</div>
            </div>
            <img class="blog__slide-img" src="/assets/image/blog/slide3.jpg" alt="slide3">
            <div class="blog__slide-content">
                <h3 class="blog__slide-title">Purus auctor auctor sociis massa lectus egestas elementum. Amet
                    quam sit
                    nisl eget.</h3>
                <div class="blog__slide-info">
                    <div class="blog__slide-date">November 23, 2022</div>
                    <span>
                        <svg width="4" height="4" viewBox="0 0 4 4" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <circle cx="2" cy="2" r="2" fill="#9195A1" />
                        </svg>
                    </span>
                    <div class="blog__slide-name">Jhon Frinz</div>
                </div>
            </div>
        </a>
        <a href="" class="blog__slide swiper-slide">
            <div class="blog__slide-tags">
                <div class="blog__slide-tag tag">Gaming</div>
            </div>
            <img class="blog__slide-img" src="/assets/image/blog/slide1.jpg" alt="slide1">
            <div class="blog__slide-content">
                <h3 class="blog__slide-title">Purus auctor auctor sociis massa lectus egestas elementum. Amet
                    quam sit
                    nisl eget.</h3>
                <div class="blog__slide-info">
                    <div class="blog__slide-date">November 23, 2022</div>
                    <span>
                        <svg width="4" height="4" viewBox="0 0 4 4" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <circle cx="2" cy="2" r="2" fill="#9195A1" />
                        </svg>
                    </span>
                    <div class="blog__slide-name">Jhon Frinz</div>
                </div>
            </div>
        </a>
        <a href="" class="blog__slide swiper-slide">
            <div class="blog__slide-tags">
                <div class="blog__slide-tag tag">Gaming</div>
            </div>
            <img class="blog__slide-img" src="/assets/image/blog/slide2.jpg" alt="slide2">
            <div class="blog__slide-content">
                <h3 class="blog__slide-title">Purus auctor auctor sociis massa lectus egestas elementum. Amet
                    quam sit
                    nisl eget.</h3>
                <div class="blog__slide-info">
                    <div class="blog__slide-date">November 23, 2022</div>
                    <span>
                        <svg width="4" height="4" viewBox="0 0 4 4" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <circle cx="2" cy="2" r="2" fill="#9195A1" />
                        </svg>
                    </span>
                    <div class="blog__slide-name">Jhon Frinz</div>
                </div>
            </div>
        </a>
        <a href="" class="blog__slide swiper-slide">
            <div class="blog__slide-tags">
                <div class="blog__slide-tag tag">Gaming</div>
            </div>
            <img class="blog__slide-img" src="/assets/image/blog/slide3.jpg" alt="slide3">
            <div class="blog__slide-content">
                <h3 class="blog__slide-title">Purus auctor auctor sociis massa lectus egestas elementum. Amet
                    quam sit
                    nisl eget.</h3>
                <div class="blog__slide-info">
                    <div class="blog__slide-date">November 23, 2022</div>
                    <span>
                        <svg width="4" height="4" viewBox="0 0 4 4" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <circle cx="2" cy="2" r="2" fill="#9195A1" />
                        </svg>
                    </span>
                    <div class="blog__slide-name">Jhon Frinz</div>
                </div>
            </div>
        </a>
    </div>
</div>